module.exports = __webpack_public_path__ + "static/media/Serverless_Udagram_App_v.1.04d22b7f.png";